
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/demo/codeDemo/plugin.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-markdown/demo/codeDemo/plugin.md?type=demo')
};